import MediaQuery from '../lib/MediaQuery';

export default function v1DestinationsCheck() {
  /**
   * SVGマップのサイズをブレイクポイントごとに変更する。
   * IEがSVGタグのフルードに対応していないため。
   */
  const mapArea = document.getElementById('v1-destinationsCheck__mapArea');
  if (!mapArea) return;
  const svg = mapArea.querySelector('svg');
  const svgWidth = parseInt(svg.getAttribute('width'), 10);
  const svgHeight = parseInt(svg.getAttribute('height'), 10);

  const setSvgSize = width => {
    const magnification = width / svgWidth;
    svg.setAttribute('width', `${svgWidth * magnification}px`);
    svg.setAttribute('height', `${svgHeight * magnification}px`);
  };

  MediaQuery.matches('xs', matches => {
    if (matches) {
      setSvgSize(631);
    }
  });

  MediaQuery.matches('sm', matches => {
    if (matches) {
      setSvgSize(720);
    }
  });

  MediaQuery.matches('md', matches => {
    if (matches) {
      setSvgSize(1100);
    }
  });

  MediaQuery.matches('lg', matches => {
    if (matches) {
      setSvgSize(980);
    }
  });

  MediaQuery.matches('xl', matches => {
    if (matches) {
      setSvgSize(1250);
    }
  });

  /**
   * SVGタグ内のaタグをマウスオーバーしたら背景色を変更する。
   * `v1-headerDestinations_prefecture hokkaido`のように設定して、対応するid（ここでは`hokkaido`）と紐づける。
   */
  const areaCheckbox = document.querySelectorAll('.v1-destinationsCheck__areasCheckbox');
  const areaGroup = document.querySelectorAll('[data-area]');
  const isTouchDevice = window.ontouchstart === null;

  Array.from(areaCheckbox).forEach(item => {
    if (!isTouchDevice) {
      item.nextElementSibling.addEventListener('mouseover', e => {
        const checkbox = e.target.closest('label').previousElementSibling;
        const area = document.querySelector(`[data-area="${checkbox.getAttribute('id')}"]`);

        area.setAttribute('class', '-hover');
      });

      item.nextElementSibling.addEventListener('mouseleave', e => {
        const checkbox = e.target.closest('label').previousElementSibling;
        const area = document.querySelector(`[data-area="${checkbox.getAttribute('id')}"]`);

        area.setAttribute('class', '');
      });

      item.addEventListener('focus', e => {
        const area = document.querySelector(`[data-area="${e.target.getAttribute('id')}"]`);
        area.setAttribute('class', '-hover');
      });

      item.addEventListener('blur', e => {
        const area = document.querySelector(`[data-area="${e.target.getAttribute('id')}"]`);
        area.setAttribute('class', '');
      });
    }

    item.addEventListener('change', e => {
      const isChecked = !!e.target.checked;
      const area = document.querySelector(`[data-area="${e.target.getAttribute('id')}"]`);

      if (isChecked) {
        area.setAttribute('aria-selected', 'true');
        return;
      }

      area.setAttribute('aria-selected', 'false');
    });
  });

  Array.from(areaGroup).forEach(area => {
    if (!isTouchDevice) {
      area.addEventListener('mouseover', e => {
        const checkbox = document.getElementById(
          e.target.closest('g[data-area]').getAttribute('data-area'),
        );
        checkbox.classList.add('-hover');

        e.target.closest('g[data-area]').setAttribute('class', '-hover');
      });

      area.addEventListener('mouseleave', e => {
        const checkbox = document.getElementById(e.target.closest('g').getAttribute('data-area'));
        checkbox.classList.remove('-hover');
        e.target.closest('g').setAttribute('class', '');
      });
    }

    area.addEventListener('click', e => {
      const dataArea = e.target.closest('g');
      const checkbox = document.getElementById(dataArea.getAttribute('data-area'));
      const isSelected = dataArea.getAttribute('aria-selected') === 'true';
      checkbox.click();
      if (isSelected) {
        dataArea.setAttribute('aria-selected', 'false');
        return;
      }
      dataArea.setAttribute('aria-selected', 'true');
    });
  });
}
